import { Pipe, PipeTransform } from "@angular/core";

/**
 * Filtro responsável por fazer interpolação customizada de dados,
 * substituindo ocorrências no formato '{número}' pelo parâmetro informado.
 * Ex.: Sendo message igual a "Olá {0} {1}!" e 'parameters' igual à ['planeta', 'Terra'],
 * o resultado seria "Olá planeta Terra!"
 */
@Pipe({
    name: "formatString"
})
export class FormatStringPipe implements PipeTransform {

    transform(message: string, parameters: string[]): string {
        return parameters.reduce(
            (msg, param, index) => msg.replace(`{${index}}`, param),
            message
        );
    }
}
